export default [
  {
    path: "/futures",
    name: "ieo",
    redirect: "/futures/earn",
    component: () => import("@/layout/index"),
    children: [
      {
        path: "earn",
        name: "earn", // index
        component: () => import("@/pages/v2/earn"),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/v2/earn.js